module.exports = __webpack_public_path__ + "media/images/favicons/favicon-16x16-212236e66fbe93b3b872440fb05c6407.png";